import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { BookingsView } from '../../../modules/bookings/bookings-view'
import '../../../modules/bookings/register-panels'

const bookingsSearchSchema = z.object({
  q: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  tab: z.enum(['upcoming', 'pending', 'past', 'cancelled', 'all']).optional(),
  owner: z.enum(['mine', 'all']).optional(),
  panel: z.string().optional(),
  panelId: z.string().optional(),
})

export const Route = createFileRoute('/_authed/bookings/')({
  validateSearch: bookingsSearchSchema,
  component: BookingsRoute,
})

function BookingsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <BookingsView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => {
            const next: Record<string, unknown> = { ...prev, ...patch }
            for (const [key, value] of Object.entries(next)) {
              if (value == null || value === '') delete next[key]
            }
            return next
          }) as never,
          replace: true,
        })
      }
    />
  )
}
